import * as React from 'react';
import Svg, { SvgProps, Rect } from 'react-native-svg';

const PausedIcon = (props: SvgProps) => <Svg
  width='8'
  height='10'
  viewBox='0 0 8 10'
  fill='none'
  {...props}
>
  <Rect
    width='2'
    height='10'
    fill='#674B16'
  />
  <Rect
    x='6'
    width='2'
    height='10'
    fill='#674B16'
  />
</Svg>;

export default PausedIcon;
